<template>
<div class="fc-page ft-page"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="ft-breadcrumb"/></nav>
<header class="fc-heading"><div class="fc-child-heading"><h1>收支流水查询</h1><p>按收支类型和日期查询，核对每笔收支记录</p></div><v-btn @click="showAddDialog" color="#d9363e" depressed class="ft-create"><v-icon left size="18">mdi-plus</v-icon>手工记账</v-btn></header>
<section class="fc-filters" aria-label="收支流水查询筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查询当前校区记录</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell">
							<v-select :items="inOutItems" v-model="query.inOut"
							item-text="text" item-value="id" label="收入/支出" dense outlined clearable @change="queryInOutChanged" color="#d9363e" aria-label="收入/支出"></v-select>
						</div>
<div class="fc-filter-cell">
							<v-select :items="query.tradeCodeList" v-model="query.typeCode"
							item-text="typeName" item-value="typeCode" label="业务类型" dense outlined clearable color="#d9363e" aria-label="业务类型"></v-select>
						</div>
<div class="fc-filter-cell">
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
							    transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="开始日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable locale="zh-Hans" color="#d9363e">
								</v-date-picker>
							</v-menu>
						</div>
<div class="fc-filter-cell">
							<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								 transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="结束日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-Hans" color="#d9363e">
								</v-date-picker>
							</v-menu>
						</div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><div class="fc-filter-actions"><v-btn type="submit" depressed color="#d9363e" dark :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section>
<section class="fc-records" aria-label="收支流水"><div class="fc-list-heading"><h3>收支流水</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table ft-table ft-trade_flow_list"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">


			<template v-slot:item.inOut="{item}">

				<span v-if="item.inOut=='1'" class="fc-status fc-status-normal">收入</span>
				<span v-if="item.inOut=='2'" class="fc-status fc-status-inactive">支出</span>
			</template>
			<template v-slot:item.amount="{item}">
				<div v-if="item.inOut=='1'" class="fc-number ft-income">
					<span style="font-size:16px">+</span>
					<span style="font-size:15px" class="ml-1" >{{item.amount}}</span>
				</div>
				<div v-if="item.inOut=='2'" class="fc-number ft-expense">
					<span style="font-size:16px" >-</span>
					<span class="ml-1" style="font-size:15px">{{item.amount}}</span>
				</div>
			</template>


<template v-slot:item.memo="{item}"><div class="fc-memo">{{item.memo}}</div></template>
</v-data-table><div class="fc-page-summary"><span>本页统计</span><span>合计收入 <strong>{{sumTotalInAmount}}</strong> 元</span><span>合计支出 <strong>{{sumTotalOutAmount}}</strong> 元</span></div><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[15, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="7" v-model="query.page" color="#d9363e"/></div></section>
<v-dialog title="手工记账" v-model="add.dialog" max-width="600" persistent scrollable>
		<v-card class="fc-dialog-card ft-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-notebook-edit-outline</v-icon></span><div><h2>手工记账</h2><p>填写业务日期、科目与金额</p></div><v-spacer/><v-btn icon aria-label="关闭手工记账" @click="add.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-sheet class="fc-form-sheet">
					<v-row  dense>

						<v-col cols="12" sm="6">
							<v-select :items="inOutItems" v-model="add.trade.inOut" @change="inOutChanged"
							item-text="text" item-value="id" label="收入/支出" dense outlined clearable color="#d9363e" aria-label="收入/支出"></v-select>
						</v-col>
						<v-col cols="12" sm="6" class="d-flex">
							<v-select :items="add.tradeCodeList" v-model="add.trade.tradeCode"
							item-text="typeName" item-value="typeCode" label="科目" dense outlined clearable color="#d9363e" aria-label="科目"></v-select>
							<v-btn class="ml-1" @click="create_subject.dialog=true" color="#d9363e" outlined>添加</v-btn>
						</v-col>
						<v-col cols="12" sm="6">
							<v-text-field label="金额" v-model="add.trade.amount" type="number" dense
								outlined color="#d9363e" aria-label="金额"></v-text-field>
						</v-col>
						<v-col cols="12" sm="6">
							<v-menu ref="menu3" v-model="menu3" :close-on-content-click="false"
								 transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="add.trade.bizDate" label="业务日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="业务日期"></v-text-field>
								</template>
								<v-date-picker v-model="add.trade.bizDate" @input="menu3=false" no-title scrollable locale="zh-Hans" color="#d9363e">
								</v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12">
							<v-text-field label="备注" v-model="add.trade.memo" dense outlined color="#d9363e" aria-label="备注">
							</v-text-field>
						</v-col>
					</v-row>
				</v-sheet>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="add.dialog=false" color="#65758c" outlined>取消</v-btn>
				<v-btn @click="submitAdd" :disabled="add.submitting" :loading="add.submitting" class="fc-confirm" color="#d9363e" depressed>确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<v-dialog title="添加自定义科目" v-model="create_subject.dialog" max-width="460" persistent scrollable>
		<v-card class="fc-dialog-card ft-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-playlist-plus</v-icon></span><div><h2>创建自定义科目</h2><p>选择收支类型，填写科目名称</p></div><v-spacer/><v-btn icon aria-label="关闭创建自定义科目" @click="create_subject.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-sheet class="fc-form-sheet">
					<v-row  dense>

						<v-col cols="12">
							<v-select :items="inOutItems" v-model="create_subject.subject.inOut"
							item-text="text" item-value="id" label="收入/支出" dense outlined clearable color="#d9363e" aria-label="收入/支出"></v-select>
						</v-col>

						<v-col cols="12">
							<v-text-field label="科目名称" v-model="create_subject.subject.subjectName" dense outlined color="#d9363e" aria-label="科目名称">
							</v-text-field>
						</v-col>
					</v-row>
				</v-sheet>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="create_subject.dialog=false" color="#65758c" outlined>取消</v-btn>
				<v-btn @click="submitAddSubject" :disabled="create_subject.submitting" :loading="create_subject.submitting" class="fc-confirm" color="#d9363e" depressed>确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog></div>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "trade-flow-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单 
				menu3: false, 
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '财务台账',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '业务日期',
							value: 'bizDate',
							sortable: false,
						},
						{
							text: '收入/支出',
							value: 'inOut',
							sortable: false,
						},
						{
							text: '业务类型',
							value: 'typeName',
							sortable: false,
						},
						{
							text: '金额',
							value: 'amount',
							sortable: false,
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false,
						},
						{
							text: '备注',
							align: 'left',
							value: 'memo',
							sortable: false
						},
					],
					list: [],
				},
				selectTradeTypeList:[],
				inOutItems:[
					{id:"1",text:"收入"},
					{id:"2",text:"支出"},
				],
				query: {
					loading: false,
					tradeCodeList:[],
					page: 1,
					size: 15,
					start: "",
					end: "",
					inOut:"",
					typeCode:""
				},
				add:{
					dialog:false,
					submiting:false,
					tradeCodeList:[],
					trade:{
						shopId:"",
						inOut:"",
						amount:"",
						memo:"",
						tradeCode:""
					}
				},
				create_subject:{
					dialog:false,
					submiting:false,
					subject:{
						inOut:"",
						subjectName:""
					}
				}
			}
		},
		created() {
			// 获取门店列表
			this.shopId = utils.getCurrentShopId()
			this.getTradeTypeListForSelect();
			this.getTableDataList();
		},
		computed:{
			
			// 总缴费汇总
			sumTotalInAmount(){
				let result = 0;
				if(this.data.list){
					this.data.list.forEach((item,index)=>{
						if (item.inOut=='1'){
							result = result+ parseFloat(item.amount);
						}
					})
				}
				
				return result.toFixed(2);
			},
			sumTotalOutAmount(){
				let result = 0;
				if(this.data.list){
					this.data.list.forEach((item,index)=>{
						if (item.inOut=='2'){
							result = result+ parseFloat(item.amount);
						}
					})
				}
				
				return result.toFixed(2);
			}
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAddDialog(){
				this.add.dialog = true;
				
				this.add.trade.shopId = "";
				this.add.trade.inOut = "";
				this.add.trade.amount = "";
				this.add.trade.memo = "";
				this.add.trade.bizDate = utils.getNowDate();
				
			},
			submitAdd(){
				
				// 提交充值
				if(!this.add.trade.inOut){
					this.$noty.error("类型不能为空")
					return
				}
				if(!this.add.trade.amount){
					this.$noty.error("请输入付费金额")
					return
				}
				if(!this.add.trade.tradeCode){
					this.$noty.error("请选择科目")
					return
				}
				if(!this.add.trade.bizDate){
					this.$noty.error("请选择业务日期")
					return
				}
				
				this.add.submitting = true;
				
				// api
				const that = this;
				let url = `/financial/trade/manual/create`;
				let postData = {
					...this.add.trade
				}
				postData.shopId = this.shopId;
				
				this.axios.post(url, postData).catch(() => {
					that.add.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							that.add.submitting = false;
							return;
						} else {
							that.add.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
			submitAddSubject(){
				
				// 提交充值
				if(!this.create_subject.subject.inOut){
					this.$noty.error("类型不能为空")
					return
				}
				if(!this.create_subject.subject.subjectName){
					this.$noty.error("请输入科目名称")
					return
				}
				
				this.create_subject.submitting = true;
				
				// api
				const that = this;
				let url = `/sys/trade/type/create`;
				let postData = {
					...this.create_subject.subject
				}
				postData.shopId = this.shopId;
				
				console.log(postData);
				
				this.axios.post(url, postData).catch(() => {
					that.create_subject.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTradeTypeListForSelect();
							that.create_subject.dialog = false;
							that.create_subject.submitting = false;
							return;
						} else {
							that.create_subject.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.create_subject.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
			
			inOutChanged(){
				console.log("in out changed");
				const inOut = this.add.trade.inOut;
				
				console.log("in out:",inOut);
				
				this.add.tradeCodeList = [];
				
				console.log(this.selectTradeTypeList);
				
				this.selectTradeTypeList.forEach((item,index)=>{
					if (item.inOut === inOut && item.useType ==='2'){
						this.add.tradeCodeList.push({typeCode:item.typeCode,typeName:item.typeName});
					}
				})
				
			},
			queryInOutChanged(){
				
				//查询的收入支出切换
				
				const inOut = this.query.inOut;
				
				console.log("in out:",inOut);
				
				this.query.tradeCodeList = [];
				
				if (!inOut){
					this.query.tradeCodeList = this.selectTradeTypeList;
				}else{
					this.selectTradeTypeList.forEach((item,index)=>{
						if (item.inOut === inOut ){
							this.query.tradeCodeList.push({typeCode:item.typeCode,typeName:item.typeName});
						}
					})
				}
				
				
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				let url = `/financial/trade/flow/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if (this.query.inOut) {
					url += "&inOut=" + this.query.inOut;
				}
				
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				
				if (this.query.typeCode) {
					url += "&typeCode=" + this.query.typeCode;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			inOutName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "收入";
				} else if (state === "2") {
					stName = "支出";
				}
				return stName;
			},
			inOutColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "error";
				}
				return color;
			},
			getTradeTypeListForSelect(){
				const that = this;
				let url = `/sys/trade/type/list`;
				if (this.shopId) {
					url += "?shopId=" + this.shopId;
				}
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectTradeTypeList = response.data["data"] ? response.data["data"] : [];
						that.query.tradeCodeList = that.selectTradeTypeList;
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/financial-tools.scss"></style>
